import type { Lang } from './i18n.js';

/**
 * The emergency copy (owner 2026-10-20): the API hands each person the links to their Google Sheets in /api/me, and this
 * device keeps them, so the sign-in page can point to them on a day the Hub can't be reached. Only Google Sheets links
 * are kept or shown.
 */
export interface EmergencyLink {
  kind: 'producer' | 'mine';
  label: string;
  url: string;
}

const KEY = 'kff.emergency';
const SHEET = /^https:\/\/docs\.google\.com\/spreadsheets\/d\/[A-Za-z0-9_-]+\/edit$/;

export function keepEmergency(links: EmergencyLink[] | undefined) {
  try {
    const ok = (links ?? []).filter((l) => SHEET.test(l.url));
    if (ok.length) localStorage.setItem(KEY, JSON.stringify(ok));
    else localStorage.removeItem(KEY);
  } catch {
    /* private mode: nothing is kept */
  }
}

export function keptEmergency(): EmergencyLink[] {
  try {
    const v = JSON.parse(localStorage.getItem(KEY) ?? '[]') as EmergencyLink[];
    return Array.isArray(v) ? v.filter((l) => l && typeof l.label === 'string' && SHEET.test(l.url)) : [];
  } catch {
    return [];
  }
}

const TX = {
  sv: { title: 'Nödlägeskopia', body: 'Kommer du inte in i Hubben just nu? Dina projekt, videor och datum finns i Google Drive, uppdaterade varje timme.' },
  en: { title: 'Emergency copy', body: "Can't get into the Hub right now? Your projects, videos and dates are in Google Drive, updated every hour." }
};

/** The kept links, shown under a failed sign-in or link page; nothing when this device has none. */
export function EmergencyLinks(p: { lang: Lang }) {
  const links = keptEmergency();
  if (!links.length) return null;
  const t = TX[p.lang];
  return (
    <div class="login-alert login-alert--info" role="status">
      <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 5h16v14H4zM4 10h16M10 10v9" /></svg>
      <div>
        <strong>{t.title}</strong>
        {t.body}
        <span class="emergency-links">
          {links.map((l) => (
            <a key={l.url} class="btn btn-sm" href={l.url} target="_blank" rel="noopener noreferrer">
              {l.label}
            </a>
          ))}
        </span>
      </div>
    </div>
  );
}
